import React from "react";
import PageHeader from "../components/PageHeader";

/**
 * PLACEHOLDER — the route and nav entry are reserved here so that the follow-up
 * engine's UI can land without touching App.js or AppLayout.jsx, which three
 * concurrent work streams all need.
 *
 * Replaced by the real work queue once GET /api/my-day exists.
 */
export default function MyDay() {
  return (
    <div>
      <PageHeader
        eyebrow="Telesales"
        title="My Day"
        description="Your call queue — overdue, due today, and new leads at SLA risk."
      />
      <div className="px-8 py-16 text-center" data-testid="my-day-placeholder">
        <p className="text-sm text-muted-foreground">
          Being built. Callbacks scheduled on a lead will appear here.
        </p>
      </div>
    </div>
  );
}
